export default "__VITE_ASSET__DQfXBzV9__"